/**
 * @Author : ShaJiaJing
 * @Date : 2019/5/29
 * @Version : 1.0
 * @Content :
 */
import BIcon from './BIcon'

export default BIcon
